import { render, staticRenderFns } from "./ResponsibilityAssignmentsTable.vue?vue&type=template&id=ace41e5c&scoped=true"
import script from "./ResponsibilityAssignmentsTable.vue?vue&type=script&lang=js"
export * from "./ResponsibilityAssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityAssignmentsTable.vue?vue&type=style&index=0&id=ace41e5c&prod&lang=css"
import style1 from "./ResponsibilityAssignmentsTable.vue?vue&type=style&index=1&id=ace41e5c&prod&scoped=true&lang=css"
import style2 from "./ResponsibilityAssignmentsTable.vue?vue&type=style&index=2&id=ace41e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace41e5c",
  null
  
)

export default component.exports